<template>
  <div class="about-cont com-padding-top-30 com-padding-bottom-40">
    <div class="com-content-1560">
      <!--
      <div class="dn-upper">
        <div class="dn-top">
          <div class="com-title1">Group headquarters</div>
        </div>
        <div class="dn-bot com-padding-top-30">
          <div id="allmap" class="allmap" ref="allmap"></div>
        </div>
      </div>
-->
      <div class="dn-lower">
        <div class="swiper-container swiper1">
          <div class="swiper-wrapper wrapper1">
            <div class="swiper-slide slide1">
              <div class="dp-top">
                <b>{{ headquarters.title }}</b>
                <i class="iconfont icon-daohangdizhi"></i>
              </div>
              <div class="dp-bot">
                <div class="dp-pai">
                  <div class="dp-p1">
                    <b>Company email</b>
                    <i class="iconfont icon-youxiang"></i>
                  </div>
                  <div class="dp-p2">E-mail:{{ headquarters.email }}</div>
                </div>
                <div class="dp-pai">
                  <div class="dp-p1">
                    <b>Company address</b>
                    <i class="iconfont icon-daohangdizhi"></i>
                  </div>
                  <div class="dp-p2">{{ headquarters.address }}</div>
                </div>
                <div class="dp-pai">
                  <div class="dp-p1">
                    <b>Contact information</b>
                    <i class="iconfont icon-dianhua1"></i>
                  </div>
                  <div class="dp-p2">Telephone：{{ headquarters.kefu_tel }}</div>
                </div>
              </div>
            </div>
            <!--
            <div class="swiper-slide slide1"
                 v-for="(item, index) in dataHomeblock" :key="index">
              <div class="dp-top">
                <b>{{ item.title }}</b>
                <i class="iconfont icon-daohangdizhi"></i>
              </div>
              <div class="dp-bot">
                <div class="dp-pai">
                  <div class="dp-p1">
                    <b>Company email</b>
                    <i class="iconfont icon-youxiang"></i>
                  </div>
                  <div class="dp-p2">E-mail:{{ item.email }}</div>
                </div>
                <div class="dp-pai">
                  <div class="dp-p1">
                    <b>Company address</b>
                    <i class="iconfont icon-daohangdizhi"></i>
                  </div>
                  <div class="dp-p2">{{ item.address }}</div>
                </div>
                <div class="dp-pai">
                  <div class="dp-p1">
                    <b>Contact information</b>
                    <i class="iconfont icon-dianhua1"></i>
                  </div>
                  <div class="dp-p2">Telephone：{{ item.kefu_tel }}</div>
                </div>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headquarters: '',
      dataHomeblock: [],
    }
  },
  created() {
    this.dataRequestcontactus_contactUs()
  },
  methods: {
    // 联系我们
    dataRequestcontactus_contactUs() {
      this.$api.user.contactus_contactUs().then(res => {
        this.headquarters = res.data.info
        this.dataHomeblock = res.data.address
        this.methodsMap()
      })
    },
    methodsMap() {
      let longlati = this.headquarters.map.split(",");
      let long = longlati[0];
      let lati = longlati[1];
      let map = new BMapGL.Map(this.$refs.allmap);
      map.centerAndZoom(new BMapGL.Point(long, lati), 15);
      map.enableScrollWheelZoom(true);
      var marker1 = new BMapGL.Marker(new BMapGL.Point(long, lati));
      map.addOverlay(marker1);
    },
  }
}
</script>

<style scoped lang="scss">
.about-cont {
  .dn-upper {
    .allmap {
      height: 530px;
    }
  }

  .dn-lower {
    .swiper1 {
      .wrapper1 {
        flex-wrap: wrap;
      }

      .slide1 {
        margin: 12px 0 0;

        .dp-top {
          background: $background1;
          font-size: 24px;
          color: #282828;
          padding: 20px 70px;
          font-weight: 600;

          i {
            color: $color2;
            font-size: 30px;
          }
        }

        .dp-bot {
          display: flex;
          justify-content: center;
          padding: 60px 0;

          .dp-pai {
            width: calc(100% / 3 - 8%);
            margin: 0 calc(8% / 2);

            .dp-p1 {
              display: flex;
              align-items: center;
              justify-content: space-between;
              color: #333333;
              font-size: 22px;

              i {
                color: #666666;
                font-size: 20px;
              }
            }

            .dp-p2 {
              font-size: 18px;
              margin: 15px 0 0;
              padding: 30px 0 0;
              border-top: 1px solid $line1;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .about-cont {
    .dn-upper {
      .allmap {
        height: 500*$mobile-conversion;
      }
    }

    .dn-lower {
      .swiper1 {

        .slide1 {
          margin: 15*$mobile-conversion 0 0;

          .dp-top {
            font-size: 30*$mobile-conversion;
            padding: 20*$mobile-conversion 70*$mobile-conversion;

            i {
              font-size: 36*$mobile-conversion;
            }
          }

          .dp-bot {
            padding: 30*$mobile-conversion 0 60*$mobile-conversion;
            flex-wrap: wrap;

            .dp-pai {
              width: calc(100% / 1);
              margin: 20*$mobile-conversion 0;

              .dp-p1 {
                font-size: 30*$mobile-conversion;

                i {
                  font-size: 36*$mobile-conversion;
                }
              }

              .dp-p2 {
                font-size: 28*$mobile-conversion;
                margin: 15*$mobile-conversion 0 0;
                padding: 15*$mobile-conversion 0 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
